// extracted by mini-css-extract-plugin
export default {"control-buttons":"control-buttons--3fac7d","controlButtons":"control-buttons--3fac7d"};